<template>
  <div class="photo-modal">
    <div class="maintitle">
      <h4>
        Análise do Molde
      </h4>
    </div>
    <div class="contentModal">
      <div class="cardProcessPhoto">
        <div class="title">
          <h3>Abertura da Embalagem</h3>
        </div>
        <AberturaEmbalagem
          v-if="configInputs == 0 || configInputs == 1"
          :configInputs="configInputs"
        />
        <AberturaEmbalagemEdit
          v-if="configInputs == undefined"
          :configInputs="configInputs"
        />
      </div>

      <div class="cardProcessPhoto">
        <div class="title">
          <h3>Fotos Molde Fechado</h3>
        </div>
        <MoldeFechado
          v-if="configInputs == 0 || configInputs == 1"
          :configInputs="configInputs"
        />
        <MoldeFechadoEdit v-if="configInputs == undefined" />
      </div>

      <div class="cardProcessPhoto">
        <div class="title">
          <h3>Fotos do Molde Aberto</h3>
        </div>
        <MoldeAberto
          v-if="configInputs == 0 || configInputs == 1"
          :configInputs="configInputs"
        />
        <MoldeAbertoEdit
          v-if="configInputs == undefined"
          :configInputs="configInputs"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AberturaEmbalagem from "./Modules/Abertura_Embalagem.vue";
import AberturaEmbalagemEdit from "./ModulesEdit/Abertura_Embalagem.vue";
import MoldeFechado from "./Modules/Molde-Fechado.vue";
import MoldeFechadoEdit from "./ModulesEdit/Molde-Fechado.vue";
import MoldeAberto from "./Modules/Molde-Aberto.vue";
import MoldeAbertoEdit from "./ModulesEdit/Molde-Aberto.vue";

export default {
  components: {
    AberturaEmbalagem,
    MoldeAberto,
    MoldeFechado,
    AberturaEmbalagemEdit,
    MoldeAbertoEdit,
    MoldeFechadoEdit,
  },
  props: {
    configInputs: Number,
  },
  data() {
    return {
      teste: "",
      DataAllImages: {
        AberturaEmbalagem: Object,
        MoldeFechado: Object,
        MoldeAberto: Object,
      },
    };
  },
};
</script>

<style scoped>

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.photo-modal {
  padding: 0rem 2.5rem;
  opacity: 0;
  animation: fadeIn 1s ease forwards!important;
}

.maintitle {
  width: 100%!important;
  text-align: center;
  font-size: 1.4rem;
  padding: 1rem 0rem 1rem;
}

.contentModal {
  height: 100%;
  transition: 0.5s;
}

.contentModal .cardProcessRrim {
  padding: 0rem 2rem;
  width: 100%;
  position: relative;
  padding: 0rem 2.5rem 0.8rem 2.5rem;
  background-color: var(--white);
  border-radius: 0.4rem;
}

.contentModal .cardProcessRrim .title {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--font_color);
  margin-bottom: 1rem;
}

h3 {
  font-size: 1rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
}

.cardProcessPhoto {
  margin-bottom: 2rem;
}

</style>
